import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { BrowserRouter } from "react-router-dom";
import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import { theme } from "./util/theme";
import { WebgateProvider as _WebgateProvider } from "@xvia/webgate-connect";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.css";
const WebgateProvider = _WebgateProvider;
const baseName = window.__APP_BASE__ || "/";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(_jsx(React.StrictMode, { children: _jsx(BrowserRouter, Object.assign({ basename: baseName }, { children: _jsx(WebgateProvider, Object.assign({ portalUrl: process.env.PORTAL_URL }, { children: _jsx(ThemeProvider, Object.assign({ theme: theme }, { children: _jsx(StyledEngineProvider, Object.assign({ injectFirst: true }, { children: _jsx(App, {}) })) })) })) })) }));
